import Button from "src/components/general/buttonv3";
import React from "react";

const Card = (): React.JSX.Element => {
  return (
    <div className="container mx-auto flex w-full justify-center lg:mt-10">
      <div className="flex flex-col items-center justify-center px-8 lg:flex-row lg:px-0 xl:w-3/4">
        <div className="flex h-[473px] w-full flex-col justify-center text-start lg:w-1/2">
          <span className="font-bold text-3xl sm:text-5xl">Redact Enterprise</span>

          <h2 className="text-purple-100">
            Protect your orgnization from threats that leverage old posts & employee PII.{" "}
          </h2>
          <p>
            Redact.dev for enterprise allows your team to easily clean up content from 35+ platforms
            and 100+ data brokers.{" "}
          </p>

          <div className="grid gap-0 sm:grid-cols-8">
            <div className="col-span-2">
              <p className="text-white-100">
                Trusted by <br /> 100+ companies
              </p>
            </div>

            <div className="hidden w-full items-end justify-center sm:flex">
              <div className="h-[30px] w-[1px] self-center bg-brand-white/60" />
            </div>

            <div className="col-span-2">
              <p className="text-white-100">App rating</p>
              <div className="-mt-3 flex flex-row">
                <span className="icon-[bxs--star]" style={{ width: "1.2rem", height: "1.2rem" }} />
                <span className="icon-[bxs--star]" style={{ width: "1.2rem", height: "1.2rem" }} />
                <span className="icon-[bxs--star]" style={{ width: "1.2rem", height: "1.2rem" }} />
                <span className="icon-[bxs--star]" style={{ width: "1.2rem", height: "1.2rem" }} />
                <span
                  className="icon-[bxs--star-half]"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <span className="mt-0 ml-2 text-white-100">4.5</span>
              </div>
            </div>

            <div className="hidden w-full items-end justify-center sm:flex">
              <div className="h-[30px] w-[1px] self-center bg-brand-white/60" />
            </div>

            <div className="col-span-2">
              <p className="text-white-100">Made in</p>
              <div className="-mt-4 flex flex-row">
                <span
                  className="icon-[openmoji--flag-us-outlying-islands] -mt-0.5"
                  style={{ width: "1.8rem", height: "1.8rem" }}
                />
                <span className="mt-0 ml-2 text-white-100">USA</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex h-fit w-full rounded-lg bg-brand-slate lg:w-1/2">
          <div className="mt-5 mb-5 flex flex-col px-5">
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">
                Remove unwated content from 35+ platforms, including Instagram, Facebook, Twitter,
                and more
              </p>
            </div>
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">Advanced copyright protection tools</p>
            </div>
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">
                Rapid depolyment for both corporate accounts or your teams personal accounts
              </p>
            </div>
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">1:1 business support 24/7 monitoring</p>
            </div>
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">
                Advanced archiving tools, ensuring your meeting data retention policies
              </p>
            </div>
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">
                Powerful scheduler feature, to enforce time limits for how long post are live
              </p>
            </div>
            <div className="flex flex-row items-center justify-start gap-5">
              <div className="w-[1rem]">
                <span
                  className="icon-[ic--sharp-check] mr-2 text-purple-100"
                  style={{ width: "1rem", height: "1rem" }}
                />
              </div>
              <p className="w-fit">
                Data broker removals for your employees, protecting your orgnization against PII
                based attacks
              </p>
            </div>
            <div className="mt-5 flex flex-row items-center justify-start space-x-8">
              <Button
                isDisabled={false}
                buttonText="Book a demo"
                buttonURL="https://cal.com/noah-redact.dev"
                color="brandFree"
                size="sm"
              />
              <Button
                isDisabled={false}
                buttonText="Contact sales"
                buttonURL="/contact-expert"
                color="brandUltimate"
                size="sm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
